module.exports = __webpack_public_path__ + "static/img/katun11.bd98068.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/katun11.jpg
// module id = n6Lf
// module chunks = 0